import { render, staticRenderFns } from "./NewQuote.vue?vue&type=template&id=1af6f35c&scoped=true&"
import script from "./NewQuote.vue?vue&type=script&lang=js&"
export * from "./NewQuote.vue?vue&type=script&lang=js&"
import style0 from "./NewQuote.vue?vue&type=style&index=0&id=1af6f35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af6f35c",
  null
  
)

export default component.exports